// Login — Curro-branded card on the blue hero. Single Google button (browser
// navigation, not fetch, so the OAuth state/cookie dance works).
// ?denied=1 → invite-only rejection message; ?noGoogle=1 → dev hint.

import { useSearchParams, Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider.jsx";
import Icon from "../components/Icon.jsx";

function CurroMark() {
  return (
    <span className="mark" style={{
      width: 40, height: 40, borderRadius: 11, display: "grid", placeItems: "center",
      background: "var(--hero)", boxShadow: "0 6px 16px rgba(0,114,206,.32)",
    }}>
      <svg viewBox="0 0 24 24" width="25" height="25" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 7.5A6 6 0 1 0 17 16.5" />
      </svg>
    </span>
  );
}

export default function Login() {
  const { user, loading } = useAuth();
  const [params] = useSearchParams();
  const returnUrl = params.get("returnUrl") || "/";
  const denied = params.get("denied") === "1";
  const noGoogle = params.get("noGoogle") === "1";

  if (!loading && user) return <Navigate to={returnUrl} replace />;

  return (
    <div className="login-page">
      <div className="login-stack">
        <div className="login-card rise">
          <div className="login-brand">
            <CurroMark />
            <span className="word">curr<span className="dot">o</span></span>
          </div>
          <h1>Procurement Analytics</h1>
          <p className="sub">Spend analysis, A/B comparison and reporting for the Curro schools portfolio.</p>

          {denied && (
            <div className="login-error">
              This Google account is not registered. Access is invite-only —
              ask your administrator to add your email.
            </div>
          )}
          {noGoogle && (
            <div className="login-hint">
              Dev mode: Google sign-in is not configured. Use
              <code> POST /api/auth/dev-signin?email=…</code> to test.
            </div>
          )}

          <button
            type="button"
            className="google-btn"
            onClick={() => { window.location.href = `/api/auth/login?returnUrl=${encodeURIComponent(returnUrl)}`; }}
          >
            <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.2C12.4 13.4 17.7 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.7 6c4.5-4.2 6.9-10.3 6.9-17.7z"/>
              <path fill="#FBBC05" d="M10.5 28.6c-.5-1.5-.8-3-.8-4.6s.3-3.1.8-4.6l-7.9-6.2C.9 16.5 0 20.1 0 24s.9 7.5 2.6 10.8l7.9-6.2z"/>
              <path fill="#34A853" d="M24 48c6.3 0 11.6-2.1 15.5-5.7l-7.7-6c-2.1 1.4-4.8 2.3-7.8 2.3-6.3 0-11.6-3.9-13.5-9.4l-7.9 6.2C6.5 42.6 14.6 48 24 48z"/>
            </svg>
            Sign in with Google
          </button>

          <p className="login-note"><Icon name="shield" size={12} /> Access is invite-only · your administrator manages registrations.</p>
        </div>
        <div className="login-foot">The Media Crowd · Procurement Analytics</div>
      </div>
    </div>
  );
}
